exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "client-authorizations .page{display:flex;height:100%;flex-direction:column}client-authorizations .section-wrap{padding:20px}client-authorizations .content{position:relative;flex:1;background:#ebf2f3}client-authorizations .content .content-inner{flex:1;height:100%;padding-bottom:80px}client-authorizations .dialog-container{position:relative}client-authorizations adp-side-modal .side-modal-content{height:100%;overflow-y:scroll;height:calc(100% - 162px)}client-authorizations [data-loading-order]{transition:opacity 1s}client-authorizations .lazy-loading{opacity:0}@media only screen and (max-width:779px){client-authorizations adp-header-top-bar{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/pages/clientAuthorizations/clientAuthorizations.less
// module id = 443
// module chunks = 0